import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

// How often the "Now" line moves (one grid hour is 40px, so a minute is ~0.7px).
const TICK_MS = 60 * 1000;

const monotonicNow = () =>
  typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();

class TimePointer extends React.Component {
  componentDidMount() {
    this.pointer.scrollIntoView({ block: 'end' });

    // HW-1073: "now" is the server time the page was rendered with
    // (`timezone.timeNow`) plus the time elapsed since, measured on a monotonic
    // clock so changing the computer's clock can't move the line. It used to be
    // a single setTimeout, so the line stepped once and then froze.
    this.baseServerNow = parseInt(this.props.timeNow, 10);
    this.baseMonotonic = monotonicNow();
    this.timer = window.setInterval(this.tick, TICK_MS);
  }

  componentWillUnmount() {
    if (this.timer) window.clearInterval(this.timer);
  }

  tick = () => {
    const elapsedSec = Math.round((monotonicNow() - this.baseMonotonic) / 1000);
    // Shared state: check-out / check-in default times read `timezone.timeNow` too.
    this.props.fieldAttrs.onChange('timezone.timeNow', this.baseServerNow + elapsedSec);
  };

  getStyles() {
    const { daysList, timeNow } = this.props;

    return {
      left: `${Math.round(((parseInt(timeNow, 10) - parseInt(daysList[0], 10)) / 3600) * 40)}px`
    };
  }

  setRef = pointer => {
    this.pointer = pointer;
  };

  render() {
    const { filterSettings } = this.props;

    return (
      <div
        ref={this.setRef}
        className={`calendar-today-pointer calendar-today-pointer--vertical
          ${
            (filterSettings.utc === '0' && filterSettings.filter === '0') ||
            filterSettings.utc !== filterSettings.filter
              ? 'view-timezone'
              : ''
          }
        `}
        style={this.getStyles()}
      />
    );
  }
}

const mapStateToProps = state => ({
  timeNow: state.timezone.timeNow,
  filterSettings: state.filterSettings
});

export default connect(
  mapStateToProps,
  {
    ...formActions
  },
  mergeActionsToProps
)(TimePointer);
